import Cookies from 'js-cookie'

const TokenKey = 'donation_token'
const UserKey = 'LOGIN_USER'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeTokenAndUserInfo(){
  removeToken()
  Cookies.remove(UserKey)
}

export function setUserInfo(userInfo){
  return Cookies.set(UserKey,JSON.stringify(userInfo))
}

export function getUserInfo(){
  return Cookies.get(UserKey)
}
